(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6642,6635],{

/***/ 49517:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[communityId]/post/[postId]",
      function () {
        return __webpack_require__(68070);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddCommentModal_AddCommentModal; }
});

// UNUSED EXPORTS: AddCommentModal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/AttachmentButtons/index.ts + 12 modules
var AttachmentButtons = __webpack_require__(40294);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/Mentions/MentionsTextArea/index.ts + 5 modules
var MentionsTextArea = __webpack_require__(93852);
// EXTERNAL MODULE: ./koba/components/Modal/index.js + 1 modules
var Modal = __webpack_require__(97971);
// EXTERNAL MODULE: ./koba/components/Modal/ModalHeader/ModalHeader.js
var ModalHeader = __webpack_require__(70394);
;// CONCATENATED MODULE: ./koba/components/Modal/ModalHeader/index.js


// EXTERNAL MODULE: ./koba/components/Modal/ModalBody/index.js
var ModalBody = __webpack_require__(68147);
// EXTERNAL MODULE: ./koba/components/Label/index.ts + 1 modules
var Label = __webpack_require__(23185);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/colors.ts
var colors = __webpack_require__(82083);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./components/AddCommentModal/AddCommentModal.module.scss
var AddCommentModal_module = __webpack_require__(56206);
var AddCommentModal_module_default = /*#__PURE__*/__webpack_require__.n(AddCommentModal_module);
// EXTERNAL MODULE: ./utils/textHelpers.ts
var textHelpers = __webpack_require__(51661);
;// CONCATENATED MODULE: ./components/AddCommentModal/AddCommentModal.tsx


















var cx = bind_default().bind((AddCommentModal_module_default()));
var AddCommentModal = function(param) {
    var _additionalClassName = param.additionalClassName, additionalClassName = _additionalClassName === void 0 ? "" : _additionalClassName, color = param.color, cancelComment = param.cancelComment, value = param.value, handleAttachmentChange = param.handleAttachmentChange, handleMentionsChange = param.handleMentionsChange, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, _postAttachment = param.postAttachment, postAttachment = _postAttachment === void 0 ? null : _postAttachment, _renderButton = param.renderButton, renderButton = _renderButton === void 0 ? null : _renderButton, submitComment = param.submitComment, t = param.t, _isReply = param.isReply, isReply = _isReply === void 0 ? false : _isReply, _relevantMentions = param.relevantMentions, relevantMentions = _relevantMentions === void 0 ? [] : _relevantMentions, _attachment = param.attachment, attachment = _attachment === void 0 ? null : _attachment, _attachmentAltText = param.attachmentAltText, attachmentAltText = _attachmentAltText === void 0 ? "" : _attachmentAltText, _handleAttachmentAltTextChange = param.handleAttachmentAltTextChange, handleAttachmentAltTextChange = _handleAttachmentAltTextChange === void 0 ? function() {
        return null;
    } : _handleAttachmentAltTextChange, _isSubmitDisabled = param.isSubmitDisabled, isSubmitDisabled = _isSubmitDisabled === void 0 ? true : _isSubmitDisabled;
    var textClassName = cx((0,colors/* isTextDark */.aS)(color) ? "post-comment__modal-header-text--dark" : "post-comment__modal-header-text--light");
    var ref = (0,react.useState)(false), isEditing = ref[0], setIsEditing = ref[1];
    var ref1 = (0,react.useState)(isSubmitDisabled), submitButtonDisabled = ref1[0], setSubmitButtonDisabled = ref1[1];
    var ref2 = (0,react.useState)(false), isAttachmentUploading = ref2[0], setIsAttachmentUploading = ref2[1];
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    (0,react.useEffect)(function() {
        setSubmitButtonDisabled(isSubmitDisabled);
    }, [
        isSubmitDisabled
    ]);
    var openCommentModal = function() {
        document.body.style.overflow = "hidden";
        setIsEditing(true);
        setSubmitButtonDisabled(false);
    };
    var closeCommentModal = function() {
        setIsEditing(false);
        document.body.style.overflow = "visible";
        cancelComment();
    };
    var postComment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var status;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isEditing) setSubmitButtonDisabled(true);
                        _ctx.next = 3;
                        return submitComment();
                    case 3:
                        status = _ctx.sent;
                        if (status === constants/* SUCCESS */.MR) {
                            setIsEditing(false);
                        }
                        document.body.style.overflow = "visible";
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function postComment() {
            return _ref.apply(this, arguments);
        };
    }();
    var onAttachmentUploading = (0,react.useCallback)(function() {
        setIsAttachmentUploading(true);
        if (!isEditing) setSubmitButtonDisabled(true);
    }, [
        attachment
    ]);
    var onAttachmentChange = (0,react.useCallback)(function(updatedAttachment) {
        handleAttachmentChange(updatedAttachment);
        setIsAttachmentUploading(false);
        if (!isEditing) setSubmitButtonDisabled(false);
    }, [
        attachment
    ]);
    var onAltTextChange = (0,react.useCallback)(function(altText) {
        handleAttachmentAltTextChange(altText);
        if (!isEditing) setSubmitButtonDisabled(false);
    }, [
        attachment
    ]);
    var buttonLabel = isReply ? t("Post reply") : t("Post comment");
    var mentionsEnabledPlaceholder = t("Type @ to mention another member in your comment");
    var postLabel = isReply ? t("components-addCommentModal-post_a_reply", "Post a reply...") : mentionsEnabledPlaceholder;
    var disableSubmitButton = !attachment && !(0,textHelpers/* isValidText */.Gq)(value) || submitButtonDisabled || isAttachmentUploading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderButton && renderButton(openCommentModal, value),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                closeModal: closeCommentModal,
                isOpen: isOpen || isEditing,
                modalBodyClasses: cx("post-comment__modal"),
                isFullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader/* default */.Z, {
                        className: textClassName,
                        "data-qa": "add-comment-modal-header",
                        style: {
                            backgroundColor: color
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                                appearance: "knockout",
                                ariaLabel: t("Close modal"),
                                "data-qa": "close-modal",
                                id: "close-modal",
                                onClick: closeCommentModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    className: textClassName,
                                    name: "x-dismiss"
                                })
                            }),
                            isReply ? t("Reply") : t("Comment"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                                appearance: "knockout",
                                ariaLabel: buttonLabel,
                                color: color,
                                "data-qa": "post-comment",
                                id: "post-comment",
                                isDisabled: disableSubmitButton,
                                onClick: postComment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    className: textClassName,
                                    name: "plane"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody/* default */.Z, {
                        className: cx("post-comment__modal-body", "is-mentions-text-area"),
                        hasTitle: true,
                        isFullWidth: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                className: cx("sr-only"),
                                htmlFor: constants/* COMMENT_FORM_ID */.dp,
                                children: postLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx("post-comment__attachment"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentButtons/* default */.Z, {
                                    altText: attachmentAltText,
                                    attachment: attachment,
                                    isDisabled: !!postAttachment,
                                    s3UploadPath: community.s3UploadPath,
                                    isIconOnly: true,
                                    onAltTextChange: onAltTextChange,
                                    onChange: onAttachmentChange,
                                    onUploading: onAttachmentUploading
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionsTextArea["default"], {
                                additionalClassName: additionalClassName,
                                id: "add-comment__modal",
                                placeholder: postLabel,
                                relevantMentions: relevantMentions,
                                textAreaClassName: "mentions__text-area",
                                value: value,
                                hasAutoFocus: true,
                                isModal: true,
                                onChange: handleMentionsChange
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AddCommentModal_AddCommentModal = (AddCommentModal);


/***/ }),

/***/ 26635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _AddCommentModal__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _AddCommentModal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4216);



/***/ }),

/***/ 11357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9973);




var CommunityHeader = function(param) {
    var pageTitle = param.pageTitle;
    var community = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__/* .useCommunityContext */ .v1)().community;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
            children: [
                pageTitle,
                " | ",
                community.name
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityHeader);


/***/ }),

/***/ 68642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getTotalNumberOfReplies; },
/* harmony export */   "O": function() { return /* binding */ sanitizeAttachments; }
/* harmony export */ });
var sanitizeAttachments = function(postAttachment) {
    if (!postAttachment) return undefined;
    var safeFieldNames = [
        "attachmentType",
        "attachmentUrl",
        "fileName",
        "fileSizeInBytes",
        "s3Bucket",
        "s3Key",
        "filestackId",
        "altText", 
    ];
    var attachment = {};
    // eslint-disable-next-line no-restricted-syntax, no-unused-vars
    for(var key in postAttachment){
        if (safeFieldNames.includes(key)) {
            attachment[key] = postAttachment[key];
        }
    }
    // @ts-ignore
    return attachment;
};
var getTotalNumberOfReplies = function(post) {
    var ref;
    if (!post) return 0;
    var replies = post.replies;
    var result = (replies === null || replies === void 0 ? void 0 : (ref = replies.nodes) === null || ref === void 0 ? void 0 : ref.reduce(function(total, reply) {
        var ref;
        return total + ((reply === null || reply === void 0 ? void 0 : (ref = reply.replies) === null || ref === void 0 ? void 0 : ref.totalCount) || 0);
    }, replies.totalCount)) || 0;
    return result || 0;
};


/***/ }),

/***/ 72500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EmptyState_EmptyState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./koba/components/EmptyState/EmptyState.module.scss
var EmptyState_module = __webpack_require__(13329);
var EmptyState_module_default = /*#__PURE__*/__webpack_require__.n(EmptyState_module);
;// CONCATENATED MODULE: ./koba/components/EmptyState/EmptyState.tsx





var cx = bind_default().bind((EmptyState_module_default()));
var EmptyState = function(param) {
    var actions = param.actions, className = param.className, _style = param.style, style = _style === void 0 ? {} : _style, title = param.title, titleClass = param.titleClass;
    var emptyStateClassNames = cx("empty-state", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: emptyStateClassNames,
        style: style,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H2, {
                className: cx("empty-state__title", titleClass),
                children: title
            }),
            actions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("empty-state__actions"),
                children: actions
            })
        ]
    });
};
/* harmony default export */ var EmptyState_EmptyState = (EmptyState);

;// CONCATENATED MODULE: ./koba/components/EmptyState/index.tsx



/***/ }),

/***/ 68147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ModalBody__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ModalBody__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94000);



/***/ }),

/***/ 68070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _postId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/EmptyState/index.tsx + 1 modules
var EmptyState = __webpack_require__(72500);
// EXTERNAL MODULE: ./koba/components/SkeletonPost/SkeletonPost.tsx
var SkeletonPost = __webpack_require__(99900);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/AddCommentContainer/index.ts + 1 modules
var AddCommentContainer = __webpack_require__(55154);
// EXTERNAL MODULE: ./components/AddCommentModal/index.tsx
var AddCommentModal = __webpack_require__(26635);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./schema/Post/mutations.ts
var mutations = __webpack_require__(74266);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/FollowPostButton/FollowPostButton.module.scss
var FollowPostButton_module = __webpack_require__(71897);
var FollowPostButton_module_default = /*#__PURE__*/__webpack_require__.n(FollowPostButton_module);
;// CONCATENATED MODULE: ./components/FollowPostButton/FollowPostButton.tsx













var cx = bind_default().bind((FollowPostButton_module_default()));
var FollowPostButton = function(param) {
    var post = param.post, t = param.t, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, onPostChange = param.onPostChange;
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var postFollowingMutate = function(mutate, event) {
        return function() {
            onPostChange();
            mutate({
                variables: {
                    id: post === null || post === void 0 ? void 0 : post.id,
                    numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                }
            });
            var attachment = (post === null || post === void 0 ? void 0 : post.postAttachments) ? post === null || post === void 0 ? void 0 : post.postAttachments[0] : null;
            var ATTACHMENT = trackingEvents/* TrackingProperty.ATTACHMENT */.Ku.ATTACHMENT, PINNED_POST = trackingEvents/* TrackingProperty.PINNED_POST */.Ku.PINNED_POST, POST_ID = trackingEvents/* TrackingProperty.POST_ID */.Ku.POST_ID, POST_ID_ENCODED = trackingEvents/* TrackingProperty.POST_ID_ENCODED */.Ku.POST_ID_ENCODED, POST_TYPE = trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE;
            var _obj;
            trackEvent(event, (_obj = {}, (0,_define_property/* default */.Z)(_obj, ATTACHMENT, attachment ? attachment.attachmentType : null), (0,_define_property/* default */.Z)(_obj, PINNED_POST, !!(post === null || post === void 0 ? void 0 : post.pinnedAt)), (0,_define_property/* default */.Z)(_obj, POST_ID, (0,rawId/* rawId */.b)((post === null || post === void 0 ? void 0 : post.id) || "")), (0,_define_property/* default */.Z)(_obj, POST_ID_ENCODED, post === null || post === void 0 ? void 0 : post.id), (0,_define_property/* default */.Z)(_obj, POST_TYPE, constants/* EVENT_POST_TYPES.POST */.Aj.POST), _obj));
        };
    };
    if (post === null || post === void 0 ? void 0 : post.isFollowing) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
            mutation: mutations/* UNFOLLOW_POST_MUTATION */.JB,
            notifyOnNetworkStatusChange: true,
            children: function(mutate, param) {
                var loading = param.loading;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.ZP, {
                        appearance: "ghost",
                        className: cx("follow-post__button", "follow-post__button--with-icon"),
                        dataQA: "follow-post__button",
                        isDisabled: loading,
                        size: isMobile ? "small" : undefined,
                        onClick: postFollowingMutate(mutate, trackingEvents/* default.UNFOLLOW */.ZP.UNFOLLOW),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: cx("follow-post__button__non-hover"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        className: cx("follow-post__button__non-hover-icon"),
                                        name: "checkmark"
                                    }),
                                    t("Following")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("follow-post__button__hover"),
                                children: t("Unfollow")
                            })
                        ]
                    })
                });
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
        mutation: mutations/* FOLLOW_POST_MUTATION */.ZH,
        notifyOnNetworkStatusChange: true,
        children: function(mutate, param) {
            var loading = param.loading;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    appearance: "ghost",
                    className: cx("follow-post__button"),
                    dataQA: "follow-post__button",
                    isDisabled: loading,
                    size: isMobile ? "small" : undefined,
                    onClick: postFollowingMutate(mutate, trackingEvents/* default.FOLLOW */.ZP.FOLLOW),
                    children: t("Follow")
                })
            });
        }
    });
};
/* harmony default export */ var FollowPostButton_FollowPostButton = (FollowPostButton);

;// CONCATENATED MODULE: ./components/FollowPostButton/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./koba/components/Surface/Surface.module.scss
var Surface_module = __webpack_require__(35274);
var Surface_module_default = /*#__PURE__*/__webpack_require__.n(Surface_module);
;// CONCATENATED MODULE: ./koba/components/Surface/Surface.tsx







var Surface_cx = bind_default().bind((Surface_module_default()));
// This component only has one usage
var Surface = function(_param) {
    var children = _param.children, className = _param.className, isLessonPlayer = _param.isLessonPlayer, isRaised = _param.isRaised, tmp = _param.tag, Tag = tmp === void 0 ? "div" : tmp, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "isLessonPlayer",
        "isRaised",
        "tag"
    ]);
    var classes = Surface_cx("surface", {
        "surface--raised": isRaised,
        "surface--lesson-player": isLessonPlayer
    }, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Surface_Surface = (Surface);

;// CONCATENATED MODULE: ./koba/components/Surface/index.ts


// EXTERNAL MODULE: ./components/TopBarMobilePostPage/TopBarMobilePostPage.module.scss
var TopBarMobilePostPage_module = __webpack_require__(20818);
var TopBarMobilePostPage_module_default = /*#__PURE__*/__webpack_require__.n(TopBarMobilePostPage_module);
;// CONCATENATED MODULE: ./components/TopBarMobilePostPage/TopBarMobilePostPage.tsx












var TopBarMobilePostPage_cx = bind_default().bind((TopBarMobilePostPage_module_default()));
var TopBarMobilePostPage = function(param) {
    var additionalClassName = param.additionalClassName, post = param.post, t = param.t, lastCommentRef = param.lastCommentRef, communityWrapperRef = param.communityWrapperRef, onPostChange = param.onPostChange;
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var color = community.primaryColor;
    var renderButton = function(openCommentModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
            appearance: "default",
            color: color,
            size: "small",
            onClick: openCommentModal,
            children: t("Comment")
        });
    };
    var renderInput = function(inputProps) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCommentModal["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            additionalClassName: additionalClassName
        }, inputProps), {
            renderButton: renderButton
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Surface_Surface, {
            className: TopBarMobilePostPage_cx("comment-top-bar-mobile"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: TopBarMobilePostPage_cx("comment-top-bar-mobile__actions"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowPostButton_FollowPostButton, {
                        post: post,
                        t: t,
                        isMobile: true,
                        onPostChange: onPostChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCommentContainer["default"], {
                        communityWrapperRef: communityWrapperRef,
                        lastCommentRef: lastCommentRef,
                        parentPostId: (post === null || post === void 0 ? void 0 : post.id) || "",
                        renderChildren: renderInput,
                        t: t,
                        onCommentSubmitted: onPostChange
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TopBarMobilePostPage_TopBarMobilePostPage = (TopBarMobilePostPage);

;// CONCATENATED MODULE: ./components/TopBarMobilePostPage/index.ts


// EXTERNAL MODULE: ./schema/Post/queries.ts
var queries = __webpack_require__(95313);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./utils/mentions/index.ts
var mentions = __webpack_require__(29296);
// EXTERNAL MODULE: ./components/CommunityHeader/CommunityHeader.tsx
var CommunityHeader = __webpack_require__(11357);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./components/PostContainer/PostContainer.tsx + 4 modules
var PostContainer = __webpack_require__(977);
// EXTERNAL MODULE: ./pages/[communityId]/index.module.scss
var index_module = __webpack_require__(53831);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./pages/[communityId]/post/[postId].tsx






















var _postId_cx = bind_default().bind((index_module_default()));
var BackToCommunityButton = function(param) {
    var title = param.title, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
        appearance: "knockout",
        className: _postId_cx("button__breadcrumb"),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: "arrow-left"
            }),
            title
        ]
    });
};
var goToCommentForm = function() {
    var ref, ref1;
    var commentForm = document.getElementById(constants/* COMMENT_FORM_ID */.dp);
    // find the textArea within the mentions container
    // @ts-ignore
    commentForm = (ref1 = (ref = commentForm === null || commentForm === void 0 ? void 0 : commentForm.children[0]) === null || ref === void 0 ? void 0 : ref.children[0]) === null || ref1 === void 0 ? void 0 : ref1.children[1];
    commentForm === null || commentForm === void 0 ? void 0 : commentForm.focus();
    commentForm === null || commentForm === void 0 ? void 0 : commentForm.scrollIntoView();
};
var RightColumnButtons = function(param) {
    var color = param.color, post = param.post, t = param.t, onPostChange = param.onPostChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: _postId_cx("post-actions"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: _postId_cx("post-actions__container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                    appearance: "primary",
                    className: _postId_cx("post-actions__button"),
                    color: color,
                    onClick: goToCommentForm,
                    children: t("COMMENT")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowPostButton_FollowPostButton, {
                    post: post,
                    t: t,
                    onPostChange: onPostChange
                })
            ]
        })
    });
};
var PostPage = function(param) {
    var postListState = param.postListState;
    var ref, ref1;
    (0,react.useEffect)(function() {
        // In the future we may want to update this state properly using setState but for now :this-is-fine:
        // Did this way to avoid any unnecessary app wide re-renders
        // eslint-disable-next-line no-param-reassign
        postListState.useCacheFirst = true;
    }, []);
    var onPostChange = function() {
        // When something changes on the post page that affects whether or not a post
        // appears in the PostList, we shouldn't use cache-first when we navigate back to it
        // eslint-disable-next-line no-param-reassign
        postListState.useCacheFirst = false;
    };
    var t = (0,es/* useTranslation */.$G)().t;
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var lastCommentRef = (0,react.useRef)(null);
    var communityWrapperRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var postId = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.postId;
    var ref2 = (0,useQuery/* useQuery */.a)(queries/* POST_QUERY */._, {
        variables: {
            communityId: community.id,
            postId: postId,
            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
        },
        notifyOnNetworkStatusChange: true
    }), loading = ref2.loading, data = ref2.data;
    var post = data === null || data === void 0 ? void 0 : (ref1 = data.community) === null || ref1 === void 0 ? void 0 : ref1.post;
    var content = (0,mentions/* replaceMentions */.yq)(post === null || post === void 0 ? void 0 : post.content, post === null || post === void 0 ? void 0 : post.mentionedUsers);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityHeader/* default */.Z, {
                pageTitle: t("pages-post_title", "Post {{title}}", {
                    title: post === null || post === void 0 ? void 0 : post.title
                })
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBarMobilePostPage_TopBarMobilePostPage, {
                additionalClassName: "add-comment__modal",
                communityWrapperRef: communityWrapperRef,
                lastCommentRef: lastCommentRef,
                /* @ts-ignore */ post: post,
                t: t,
                onPostChange: onPostChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: _postId_cx("community-wrapper", "community-wrapper--post-detail"),
                ref: communityWrapperRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: _postId_cx("community-main", "community-main--full-width"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: _postId_cx("community-main__post"),
                            children: [
                                width > constants/* BREAKPOINT_MD */.GI && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToCommunityButton, {
                                    title: t("common-BACK", "BACK"),
                                    onClick: (0,routerHelpers/* goToPostListPage */.x9)(router, community.id)
                                }),
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonPost */.VJ, {}),
                                !loading && (post ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PostContainer/* default */.Z, {
                                    additionalClassName: "post__detail",
                                    author: post.user,
                                    communityWrapperRef: communityWrapperRef,
                                    content: content,
                                    goToPostListPage: (0,routerHelpers/* goToPostListPage */.x9)(router, community.id),
                                    lastCommentRef: lastCommentRef,
                                    mentionedUsers: post === null || post === void 0 ? void 0 : post.mentionedUsers,
                                    post: post,
                                    t: t,
                                    isPostPage: true,
                                    onPostChange: onPostChange
                                }, post.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* default */.Z, {
                                    className: "empty-state__full-width",
                                    title: t("Post not found")
                                }))
                            ]
                        })
                    }),
                    post && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightColumnButtons, {
                        color: community.primaryColor,
                        post: post,
                        t: t,
                        onPostChange: onPostChange
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _postId_ = (PostPage);


/***/ }),

/***/ 56206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AddCommentModal_sr-only--mobile__jDt4N","sr-only":"AddCommentModal_sr-only__D4vI2","error-message":"AddCommentModal_error-message__hH___","form-inline-edit":"AddCommentModal_form-inline-edit__fyl_p","form-group":"AddCommentModal_form-group__bEQoJ","form-row":"AddCommentModal_form-row__YmrBj","form-inline":"AddCommentModal_form-inline__PjbxL","error":"AddCommentModal_error__tmllw","input-group-append":"AddCommentModal_input-group-append__17Ezw","input-group-currency":"AddCommentModal_input-group-currency__N72qX","form-control":"AddCommentModal_form-control__T5qIl","custom-select":"AddCommentModal_custom-select___LcTn","is-invalid":"AddCommentModal_is-invalid__6K4yB","is-valid":"AddCommentModal_is-valid__TEuqW","input-group":"AddCommentModal_input-group__hTkW7","input-group-text":"AddCommentModal_input-group-text__upZu_","input-group-prepend":"AddCommentModal_input-group-prepend__p5uBG","valid-feedback":"AddCommentModal_valid-feedback__aTlyq","invalid-feedback":"AddCommentModal_invalid-feedback__gWxCb","form-text":"AddCommentModal_form-text__yR6ry","label":"AddCommentModal_label__fbJPa","custom-control":"AddCommentModal_custom-control__e5gIk","custom-control-label":"AddCommentModal_custom-control-label__nxedE","custom-control-label--empty":"AddCommentModal_custom-control-label--empty___wfFJ","custom-control-input":"AddCommentModal_custom-control-input__5jwm4","post-comment__modal":"AddCommentModal_post-comment__modal__F_Zux","post-comment__modal-header-text--dark":"AddCommentModal_post-comment__modal-header-text--dark__hfHy3","post-comment__modal-header-text--light":"AddCommentModal_post-comment__modal-header-text--light__l5j4X","post-comment__modal-body":"AddCommentModal_post-comment__modal-body__wgZ1_","is-mentions-text-area":"AddCommentModal_is-mentions-text-area__YVD8f","post-comment__attachment":"AddCommentModal_post-comment__attachment__Cjxv6","post-comment__input":"AddCommentModal_post-comment__input__7gZ2e","post-comment__input-wrapper":"AddCommentModal_post-comment__input-wrapper__27DCv"};

/***/ }),

/***/ 71897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"FollowPostButton_sr-only--mobile__zTKc0","sr-only":"FollowPostButton_sr-only__sdp3_","error-message":"FollowPostButton_error-message__guRXp","form-inline-edit":"FollowPostButton_form-inline-edit__11S71","form-group":"FollowPostButton_form-group__WOdnF","form-row":"FollowPostButton_form-row__HImlk","form-inline":"FollowPostButton_form-inline__g01_6","error":"FollowPostButton_error___OCA2","input-group-append":"FollowPostButton_input-group-append__tfETE","input-group-currency":"FollowPostButton_input-group-currency__2vRSp","form-control":"FollowPostButton_form-control___mKcL","custom-select":"FollowPostButton_custom-select__PmKUy","is-invalid":"FollowPostButton_is-invalid__ytNk_","is-valid":"FollowPostButton_is-valid__vhAnQ","input-group":"FollowPostButton_input-group__8xhVF","input-group-text":"FollowPostButton_input-group-text__1GsiA","input-group-prepend":"FollowPostButton_input-group-prepend___qruO","valid-feedback":"FollowPostButton_valid-feedback__GkcKD","invalid-feedback":"FollowPostButton_invalid-feedback__prUu1","form-text":"FollowPostButton_form-text__dmRF_","label":"FollowPostButton_label__HXH9a","custom-control":"FollowPostButton_custom-control__nWxel","custom-control-label":"FollowPostButton_custom-control-label__IdLvW","custom-control-label--empty":"FollowPostButton_custom-control-label--empty__vE7kB","custom-control-input":"FollowPostButton_custom-control-input__NSvN4","follow-post__button":"FollowPostButton_follow-post__button__w7VLo","follow-post__button__non-hover":"FollowPostButton_follow-post__button__non-hover__ykf8k","follow-post__button__hover":"FollowPostButton_follow-post__button__hover__Ls_t8","follow-post__button__non-hover-icon":"FollowPostButton_follow-post__button__non-hover-icon__Nn__q","follow-post__button--with-icon":"FollowPostButton_follow-post__button--with-icon__iefxe"};

/***/ }),

/***/ 20818:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"TopBarMobilePostPage_sr-only--mobile__fQL46","sr-only":"TopBarMobilePostPage_sr-only__r4V8M","error-message":"TopBarMobilePostPage_error-message__d6glm","form-inline-edit":"TopBarMobilePostPage_form-inline-edit__Owuj9","form-group":"TopBarMobilePostPage_form-group__oEBAT","form-row":"TopBarMobilePostPage_form-row__xM2nv","form-inline":"TopBarMobilePostPage_form-inline__Y4ERI","error":"TopBarMobilePostPage_error__vHbpy","input-group-append":"TopBarMobilePostPage_input-group-append__088xH","input-group-currency":"TopBarMobilePostPage_input-group-currency__Tk2C0","form-control":"TopBarMobilePostPage_form-control__OcsQv","custom-select":"TopBarMobilePostPage_custom-select__FOE2T","is-invalid":"TopBarMobilePostPage_is-invalid__UOgHx","is-valid":"TopBarMobilePostPage_is-valid__cL_LQ","input-group":"TopBarMobilePostPage_input-group__AQUIN","input-group-text":"TopBarMobilePostPage_input-group-text__cniJT","input-group-prepend":"TopBarMobilePostPage_input-group-prepend__gwqSm","valid-feedback":"TopBarMobilePostPage_valid-feedback__J3AyB","invalid-feedback":"TopBarMobilePostPage_invalid-feedback__4XhVt","form-text":"TopBarMobilePostPage_form-text__IobjD","label":"TopBarMobilePostPage_label__GKeqR","custom-control":"TopBarMobilePostPage_custom-control__XOuGX","custom-control-label":"TopBarMobilePostPage_custom-control-label__Tu8TN","custom-control-label--empty":"TopBarMobilePostPage_custom-control-label--empty__k9wvn","custom-control-input":"TopBarMobilePostPage_custom-control-input__yCOIx","comment-top-bar-mobile":"TopBarMobilePostPage_comment-top-bar-mobile__xznb3","comment-top-bar-mobile__follow-tag":"TopBarMobilePostPage_comment-top-bar-mobile__follow-tag__betWq","comment-top-bar-mobile__actions":"TopBarMobilePostPage_comment-top-bar-mobile__actions__JMNW1"};

/***/ }),

/***/ 13329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EmptyState_sr-only--mobile__AXD6a","sr-only":"EmptyState_sr-only__WfBEe","error-message":"EmptyState_error-message__DZ_v_","form-inline-edit":"EmptyState_form-inline-edit__CJrXl","form-group":"EmptyState_form-group__Bf9ox","form-row":"EmptyState_form-row__a_lnO","form-inline":"EmptyState_form-inline__LFw6b","error":"EmptyState_error__vDGwn","input-group-append":"EmptyState_input-group-append__fiuHO","input-group-currency":"EmptyState_input-group-currency__GL8_G","form-control":"EmptyState_form-control__KZPS9","custom-select":"EmptyState_custom-select__HDx5W","is-invalid":"EmptyState_is-invalid__nak7A","is-valid":"EmptyState_is-valid__im6cU","input-group":"EmptyState_input-group__qB_sZ","input-group-text":"EmptyState_input-group-text__DZOuK","input-group-prepend":"EmptyState_input-group-prepend__P1crH","valid-feedback":"EmptyState_valid-feedback__SobLJ","invalid-feedback":"EmptyState_invalid-feedback__lvHne","form-text":"EmptyState_form-text__E2iOO","label":"EmptyState_label__FWN94","custom-control":"EmptyState_custom-control__BquI_","custom-control-label":"EmptyState_custom-control-label__T5YrP","custom-control-label--empty":"EmptyState_custom-control-label--empty__Iu4F4","custom-control-input":"EmptyState_custom-control-input__7qCR3","empty-state":"EmptyState_empty-state__FRtXr","empty-state__title":"EmptyState_empty-state__title__AsLRC","empty-state--full-width":"EmptyState_empty-state--full-width__szXLJ"};

/***/ }),

/***/ 35274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Surface_sr-only--mobile__4jVP_","sr-only":"Surface_sr-only__oTKh3","error-message":"Surface_error-message__q8x09","form-inline-edit":"Surface_form-inline-edit__93xwx","form-group":"Surface_form-group__QfOPn","form-row":"Surface_form-row__U_EPD","form-inline":"Surface_form-inline__rYVVi","error":"Surface_error__ulQ3P","input-group-append":"Surface_input-group-append__vEeHO","input-group-currency":"Surface_input-group-currency__XIP5F","form-control":"Surface_form-control__lzyLL","custom-select":"Surface_custom-select__4MbY3","is-invalid":"Surface_is-invalid__OrAJj","is-valid":"Surface_is-valid__vzhqY","input-group":"Surface_input-group__eujpH","input-group-text":"Surface_input-group-text__DHzyB","input-group-prepend":"Surface_input-group-prepend__p7Xn8","valid-feedback":"Surface_valid-feedback__GYip5","invalid-feedback":"Surface_invalid-feedback__j_eGS","form-text":"Surface_form-text__n1llY","label":"Surface_label__lp_rz","custom-control":"Surface_custom-control__YCPrx","custom-control-label":"Surface_custom-control-label__JrH0c","custom-control-label--empty":"Surface_custom-control-label--empty__QkaiT","custom-control-input":"Surface_custom-control-input__OnRTs","surface":"Surface_surface__3lsLd","surface--raised":"Surface_surface--raised__8wmKR","surface--lesson-player":"Surface_surface--lesson-player__kThi6"};

/***/ }),

/***/ 53831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"_communityId__sr-only--mobile__Bhgf6","sr-only":"_communityId__sr-only__ayf7p","error-message":"_communityId__error-message__s5ZI3","form-inline-edit":"_communityId__form-inline-edit__SklE1","form-group":"_communityId__form-group__OVloT","form-row":"_communityId__form-row__Io5Yz","form-inline":"_communityId__form-inline__fdObK","error":"_communityId__error__4f_ni","input-group-append":"_communityId__input-group-append__vXkaN","input-group-currency":"_communityId__input-group-currency__keVnN","form-control":"_communityId__form-control__d_xOw","custom-select":"_communityId__custom-select__rdlNw","is-invalid":"_communityId__is-invalid__YLhc6","is-valid":"_communityId__is-valid__SYTE4","input-group":"_communityId__input-group__OwfFK","input-group-text":"_communityId__input-group-text__kTPod","input-group-prepend":"_communityId__input-group-prepend__8tgdE","valid-feedback":"_communityId__valid-feedback__H_loW","invalid-feedback":"_communityId__invalid-feedback__zwtiy","form-text":"_communityId__form-text__wXFae","label":"_communityId__label__UvSSx","custom-control":"_communityId__custom-control__BbxWT","custom-control-label":"_communityId__custom-control-label__D6jtC","custom-control-label--empty":"_communityId__custom-control-label--empty__fZ9cm","custom-control-input":"_communityId__custom-control-input__ATPXM","community-wrapper":"_communityId__community-wrapper__IluK9","community-wrapper--post-detail":"_communityId__community-wrapper--post-detail__sVc4V","is-spaces-in-communities-enabled":"_communityId__is-spaces-in-communities-enabled__bkhqd","community-actions":"_communityId__community-actions__maAWb","community-main":"_communityId__community-main__YJK2T","community-main--full-width":"_communityId__community-main--full-width__NSlU7","community-info":"_communityId__community-info__FNR2h","community-info--caption":"_communityId__community-info--caption__s3CCr","post-actions":"_communityId__post-actions__YzTU8","post-actions__button":"_communityId__post-actions__button__hDDrE","post-actions__container":"_communityId__post-actions__container__BsoGT","button__breadcrumb":"_communityId__button__breadcrumb__lMiK1","community-card-wrapper":"_communityId__community-card-wrapper__rJxMN","main-content":"_communityId__main-content__wEhn9","right-content":"_communityId__right-content__m9BwJ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [375,7229,5290,7859,3253,7763,1178,8764,8568,3852,3534,8175,9033,5154,9774,2888,179], function() { return __webpack_exec__(49517); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);